var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScale = function SvgScale(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "scale_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h48v48H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#scale_svg__a)",
    fill: "#004152"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.25 14c.521 0 .987.323 1.17.811l6 16a1.25 1.25 0 0 1-.422 1.44A11.266 11.266 0 0 1 37.25 34.5c-2.431 0-4.793-.788-6.748-2.249a1.25 1.25 0 0 1-.422-1.44l6-16A1.25 1.25 0 0 1 37.25 14Zm-4.482 16.763A8.75 8.75 0 0 0 37.25 32c1.581 0 3.126-.429 4.483-1.237L37.25 18.81l-4.482 11.953ZM9.25 14c.521 0 .988.323 1.17.811l6 16a1.25 1.25 0 0 1-.422 1.44A11.266 11.266 0 0 1 9.25 34.5c-2.431 0-4.793-.788-6.748-2.249a1.25 1.25 0 0 1-.422-1.44l6-16A1.25 1.25 0 0 1 9.25 14ZM4.768 30.763A8.75 8.75 0 0 0 9.25 32c1.581 0 3.126-.429 4.483-1.237L9.25 18.81 4.768 30.763ZM12 41.25c0-.69.56-1.25 1.25-1.25h20a1.25 1.25 0 0 1 0 2.5h-20c-.69 0-1.25-.56-1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.25 4c.69 0 1.25.56 1.25 1.25v36a1.25 1.25 0 0 1-2.5 0v-36c0-.69.56-1.25 1.25-1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.691 8.132a1.25 1.25 0 0 1 1.118 0C27.74 10.097 33.533 12 37.25 12h4a1.25 1.25 0 0 1 0 2.5h-4c-4.091 0-9.937-1.913-14-3.858-4.063 1.945-9.908 3.858-14 3.858h-4a1.25 1.25 0 1 1 0-2.5h4c3.717 0 9.512-1.903 13.441-3.868Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 29H4.5v2.5l5 2 5.5-2-1-2.5ZM33 29h9.5v2.5l-5 2-5.5-2 1-2.5Z"
  }))));
};
export default SvgScale;